import styled from 'styled-components';
import { gradient } from '../../../helpers/styleUtils';
import pulse from '../../../helpers/animPulse';

export const StartButtonWrap = styled.span`
  left: 50%;
  opacity: 0;
  position: absolute;
  top: 54%;
  transform: rotateX(180deg) skew(20deg) translate(-50%, -50%);
  transition: opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut};
  transition-delay: 0.7s;
  z-index: ${props => props.theme.zIndex.overlay};

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    top: 52%;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    top: 50%;
  }

  .game-wrap-enter-done & {
    opacity: 1;
    transform: rotateY(0) skew(0) translate(-50%, -50%);
    transform-origin: 0;

    &.hide {
      opacity: 0;
      transform: rotateY(90deg) skew(0) translate(-50%, -50%);
      transform-origin: 0;
      transition-duration: 0.3s;
      transition-delay: 0s;
    }
  }
`;

const StartButtonStyled = styled.button`
  ${gradient.background(
    `45deg`,
    props => props.theme.colors.quaternary,
    props => props.theme.colors.quinary
  )};
  border-radius: 100%;
  border: 0;
  box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.05);
  color: ${props => props.theme.colors.tertiary};
  cursor: pointer;
  font-family: ${props => props.theme.fonts.primary};
  font-size: calc(${props => props.theme.fonts.baseSize} + 0.75vmin);
  font-weight: 700;
  height: 80px;
  outline: 0;
  text-align: center;
  transition: opacity ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    transform ${props => props.theme.transition.durationLong}
      ${props => props.theme.transition.easeOut},
    box-shadow ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeOut};
  width: 80px;

  &:hover,
  &:focus {
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.3), 0 0 0 10px rgba(0, 0, 0, 0.05),
      0 0 30px rgba(255, 255, 255, 0.2);

    @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
      animation: ${pulse} 1s infinite ${props => props.theme.transition.easeOut};
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0.3), 0 0 0 12px rgba(0, 0, 0, 0.05),
        0 0 30px rgba(255, 255, 255, 0.2);
    }
  }

  &:not([disabled]):active {
    box-shadow: 0 0 0 rgba(255, 255, 255, 0.2), 0 0 0 8px rgba(0, 0, 0, 0.05);
    margin-top: 2px;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    box-shadow: 0 0 0 8px rgba(0, 0, 0, 0.05);
    font-size: calc(${props => props.theme.fonts.baseSize} + 0.7vmin);
    height: 100px;
    width: 100px;
  }
`;

export default StartButtonStyled;



// WEBPACK FOOTER //
// ./src/components/atoms/StartButton/StartButton.styled.js